import Vue from "vue";
import { findInFormAnswer } from "./find_in_form_answer.js";

export class RatingFormInput {
  constructor() {
    this.type = "rating";
    this.data = {
      required: false,
      question: "",
    };
  }
}

export let RatingFormInputComponent = Vue.extend({
  props: ["input"],
  template: "#rating-form-input-template",
  data: function () {
    return {
      trainee_answer: null,
    };
  },
  methods: {
    answer: function (val) {
      this.trainee_answer = val;
    },
  },
  created: function () {
    const answer = findInFormAnswer(this.input);
    if (answer !== undefined) {
      this.trainee_answer = answer;
    }
  },
  watch: {
    trainee_answer: function () {
      this.$root.onTraineeAnswer(this);
    },
  },
});
